import React from "react";
import { formatDate } from "../../components/helpers/formatDate";

/**
 * A mobile note list item showing type, date, and subject.
 */
export default function MobileNoteItem({ note, onClick }) {
  return (
    <div className="mobile-note-item" onClick={onClick}>
      <div className="mobile-note-item__header">
        <span className="mobile-note-item__type">{note.type || "Note"}</span>
        <span className="mobile-note-item__date">{formatDate(note.date_note)}</span>
      </div>
      <div className="mobile-note-item__subject">{note.subject}</div>
    </div>
  );
}

